import React, { useState, useEffect } from 'react';
import { useCore } from 'contexts/core';

const LoadingIndicator = () => {
  const core = useCore();
  const [loaded, setLoaded] = useState<boolean>(true);

  useEffect(() => {
    let timer: number;
    const onLoading = () => {
      setLoaded(false);
    };

    const onLoaded = () => {
      if (timer) clearTimeout(timer);
      timer = window?.setTimeout(() => {
        setLoaded(true);
        window?.setTimeout(() => {
          setLoaded(false);
        }, 500);
      }, 500);
    };

    const unsubscribers = [
      core.subscribe('history', onLoading),
      core.subscribe('loadVpc', onLoading),
      core.subscribe('modelLoaded', onLoaded),
      core.subscribe('loadVpcFailure', onLoaded)
    ];
    return () => {
      unsubscribers.forEach(unsubscribe => {
        unsubscribe();
      });
    };
  }, [core]);

  return loaded ? <div data-testid="done-loading"></div> : null;
};

export default LoadingIndicator;
